var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _vm.hasType
      ? _c(
          "div",
          { staticClass: "cell is-icon-cell has-text-centered cell--type" },
          [_vm._t("type")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasDate
      ? _c(
          "div",
          { staticClass: "cell is-multiple-date-cell is-editable cell--date" },
          [_vm._t("date")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasStatus
      ? _c(
          "div",
          {
            staticClass: "cell is-multiple-date-cell is-editable cell--status",
          },
          [_vm._t("status")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasNights
      ? _c(
          "div",
          { staticClass: "cell is-small-cell has-text-centered cell--nights" },
          [_vm._t("nights")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasName
      ? _c(
          "div",
          {
            staticClass: "cell is-name-cell cell--name",
            class: {
              "has-provider": _vm.hasProvider,
              "is-expanded": _vm.nameExpanded,
            },
            on: {
              click: function ($event) {
                _vm.nameExpanded = !_vm.nameExpanded
              },
            },
          },
          [_vm._t("name")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasProvider
      ? _c(
          "div",
          { staticClass: "cell is-provider-cell cell--provider" },
          [_vm._t("provider")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasCurrency
      ? _c(
          "div",
          {
            staticClass:
              "cell is-price-cell is-small is-editable cell--currency",
          },
          [_vm._t("currency")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasMarginTax
      ? _c(
          "div",
          { staticClass: "cell is-price-cell cell--margin-tax" },
          [_vm._t("marginTax")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasBuyPriceCalculation
      ? _c(
          "div",
          { staticClass: "cell is-price-cell is-half cell--buy-calc" },
          [_vm._t("buyPriceCalculation")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasBuyPrice
      ? _c(
          "div",
          {
            staticClass: "cell is-price-cell cell--buy",
            class: { "is-half": _vm.hasBuyPriceCalculation },
          },
          [_vm._t("buyPrice")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasSellPriceCalculation
      ? _c(
          "div",
          { staticClass: "cell is-price-cell is-half cell--sell-calc" },
          [_vm._t("sellPriceCalculation")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "cell is-price-cell cell--sell",
        class: { "is-half": _vm.hasSellPriceCalculation },
      },
      [_vm._t("sellPrice")],
      2
    ),
    _vm._v(" "),
    _vm.hasProfitCalculation
      ? _c(
          "div",
          { staticClass: "cell is-price-cell is-half cell--profit-calc" },
          [_vm._t("profitCalculation")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "cell is-price-cell cell--profit",
        class: { "is-half": _vm.hasProfitCalculation },
      },
      [_vm._t("profit")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "cell is-price-cell is-margin-cell cell--margin" },
      [_vm._t("margin")],
      2
    ),
    _vm._v(" "),
    _vm.actions
      ? _c(
          "div",
          { staticClass: "cell is-actions is-small-cell cell--actions" },
          [_vm._t("actions")],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }